/** Hand placed nodes and links for the neural pattern tile (320 x 200, tiles seamlessly). */
export const NEURAL_TILE = { width: 320, height: 200 } as const

export const NEURAL_NODES: ReadonlyArray<readonly [number, number, number]> = [
  [24, 30, 3],
  [88, 18, 4],
  [150, 52, 3],
  [60, 92, 5],
  [122, 120, 3],
  [196, 96, 4],
  [250, 34, 3],
  [292, 88, 4],
  [236, 150, 3],
  [170, 176, 4],
  [96, 170, 3],
  [30, 150, 4],
  [284, 180, 3],
]

const LINKS: ReadonlyArray<readonly [number, number]> = [
  [0, 1], [1, 2], [0, 3], [2, 3], [2, 5], [3, 4], [4, 5], [5, 6], [6, 7], [5, 7],
  [5, 8], [7, 8], [8, 9], [4, 9], [4, 10], [10, 11], [3, 11], [8, 12], [9, 10], [2, 6],
]

/** Line segments [x1, y1, x2, y2], including the wrap around links that make the tile seamless. */
export const NEURAL_LINES: ReadonlyArray<readonly [number, number, number, number]> = [
  ...LINKS.map(([a, b]) => [NEURAL_NODES[a][0], NEURAL_NODES[a][1], NEURAL_NODES[b][0], NEURAL_NODES[b][1]] as const),
  [292, 88, 344, 30],
  [-28, 88, 24, 30],
  [284, 180, 250, 234],
  [284, -20, 250, 34],
  [96, 170, 88, 218],
  [96, -30, 88, 18],
  [30, 150, 24, 230],
  [30, -50, 24, 30],
]
